
import React from "react";
import { View, StyleSheet } from "react-native";
import { Portal, Surface, Text, Button } from "react-native-paper";

type ConfirmBottomProps = {
  visible: boolean;
  title: string;
  message: string;
  onYes: () => void;
  onNo: () => void;
};

export function ConfirmBottom({ visible, title, message, onYes, onNo }: ConfirmBottomProps) {
  if (!visible) return null;

  return (
    <Portal>
      {/* Backdrop to block clicks */}
      <View style={styles.backdrop} />

      {/* Bottom positioned box */}
      <Surface style={styles.box} elevation={5}>
        <Text variant="titleLarge">{title}</Text>
        <Text variant="bodyMedium" style={{ marginTop: 8 }}>
          {message}
        </Text>

        <View style={styles.actions}>
          <Button onPress={onNo}>No</Button>
          <Button onPress={onYes}>Yes</Button>
        </View>
      </Surface>
    </Portal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0,0,0,0.25)",
  },
  box: {
    position: "absolute",
    bottom: 30,
    alignSelf: "center",
    width: "92%",
    maxWidth: 700,
    borderRadius: 16,
    padding: 16,
    backgroundColor: 'white'
  },
  actions: {
    marginTop: 12,
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 10,
  },
});
